<template>
	<div >
		<b-card class="p-0">
					<div class="card-header border-0">
						<b-row  class=" align-items-center">
							<b-col cols="12" lg="4" md="12" sm="12"><h6 class="mb-0">Activity Report</h6></b-col> 
							<b-col cols="6" lg="4" md="6" sm="6"> 
								<span class="mr-2">Show</span>
							<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
							</b-form-select>
								
							</b-col> 
							
							<b-col cols="6" lg="4" md="6" sm="6" class="text-right">
							<!--<b-button class="rounded-pill mr-2 fontSize9" size="sm" @click="summary_selected = summary.daily">Export CSV</b-button> -->
							<download-csv type="button" class="btn btn-dark rounded-pill mr-2" size="sm"  :data="recordsCsv" name="share_activity_report.csv" >Export CSV</download-csv>
							
							
							<b-link block v-b-toggle.salsesaAummer variant="info"> <i class="fa fa-caret-down"></i> </b-link></b-col>
							</b-row>
					</div>
				
					
					<b-collapse id="salsesaAummer" visible accordion="my-salsesaAummer" role="tabpanel"> 
					
						<b-row class="mt-4 px-3">
							<b-col lg="3" class="text-left">
								<span class="mr-2">Date From</span>
								<b-form-datepicker id="datepicker-from" v-model="datefrom" class="mb-2" size="sm" placeholder="No date"></b-form-datepicker>
							</b-col>
							<b-col lg="3" class="text-left">
								<span class="mr-2">Date To</span>
								<b-form-datepicker id="datepicker-to" v-model="dateto" class="mb-2" size="sm" placeholder="No date"></b-form-datepicker>
							</b-col>
							<!--<b-col lg="2" class="text-left">
								<span class="mr-2">Role</span>
								<b-form-select v-model="reg_role" required>
									<b-form-select-option value="">All</b-form-select-option>
									<b-form-select-option value="seller">Seller</b-form-select-option>
									<b-form-select-option value="sales-advisor">Sales Advisor</b-form-select-option>
								</b-form-select>
							</b-col>-->
							
							<b-col lg="2" class="text-left">
								<b-button pill variant="primary" class="mt-4" @click="loadData(),loading=true" size="sm">Submit</b-button>
							</b-col>
							
							
							<b-col lg="4">
								<span class="mr-2">Filter</span>
								<b-input-group >
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search" size="sm">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''" size="sm">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"  > 
								
								
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>

					
					</b-collapse>
				</b-card>
		
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>	



	</div>		
</template>
<script>

/* setpassword

http://localhost:8080/agent/dashboard/setpassword*/

//import CartVariant from "@/components/cartVariant.vue";
//import ProductRating from "@/components/product-rating.vue";

export default {
  name: 'ShareEmailPopup',
  components: {
  //"cart-variant": CartVariant,
  //"product-rating": ProductRating,
  
  },
  props: { 
	/* selectedItem: { type: Object },	
	filteredCategory: { type: Array },	
	category: { type: Array },	
	brandlist: { type: Array },	*/
  },
  mounted(){
    this.loadData();
  },
  computed: {
    
  },
  data() {
    return{
		loading: true, 
		reg_status: -1,
        datefrom: '',
		dateto: '',  
		recordUrl: this.$root.WEBAPI+'secureapi/sareport',
		recordsCsv: [],
		records: [],
		fields: [
				/* { key: 'Selected',label: 'Selected'}, 
                { key: 'id', label: 'ID'},*/
                { key: 'username', label: 'Full Name',
					formatter: (value, key, item) => { 
						return item.username;
					}
				},
                { key: 'email', label: 'Email'},
				{ key: 'phone', label: 'Mobile'},
				/* { key: 'role', label: 'Role' }, */
				{ key: 'totla_liks', label: 'Total Like',
					formatter: (value, key, item) => { 
						return item.totla_liks>0?item.totla_liks:0;
					},
					class: 'text-center'
				},
				
				{ key: 'total_views', label: 'Total Views',
					formatter: (value, key, item) => { 
						return item.total_views>0?item.total_views:0;
					},
					class: 'text-center'					
				},{ key: 'total_share', label: 'Total Shared',
					formatter: (value, key, item) => { 
						return item.total_share>0?item.total_share:0;
					},
					class: 'text-center'
				},
				
				/* { key: 'location', label: 'Location' },
				 { key: 'workarea', label: 'Work Area' },
				
				{ key: 'ipaddress', label: 'Ip Address'},
				{ key: 'platform', label: 'Platform',
					formatter: (value, key, item) => { 
						if(item.platform == null || item.platform == ''){
							return '';
						}
                        var platform = JSON.parse(item.platform);
                        //console.log(platform.platform+', '+platform.browser);
						return platform.platform+', '+platform.browser;
					},
				},*/
				 /* { key: 'reg_status', label: 'Status'},
				{ key: 'account_created', label: 'Account'},
              { key: 'insert_time', label: 'Time'},
                { key: 'lastLoginTime', label: 'Login'},
				{ key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' }*/
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [25,50,100,200,300,500],
			perPage: 25,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {product_data:{}, tier_price:[]},
		 
		
    }
  },
  methods:{
	loadData(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key'),
				datefrom: self.datefrom,
				dateto: self.dateto,
				role: self.reg_role,
				status: self.reg_status
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.records;
					self.loading = false;
					self.totalRows = self.records.length;
					self.recordsCsv=[];
					self.records.forEach(item => {
						var arrayCsv={'Sales Advisor Name':item.username,'Phone':item.phone,'Total Link':item.totla_liks>0?item.totla_liks:0,'Total View':item.totla_view>0?item.totla_view:0,'Total Shared':item.total_share>0?item.total_share:0};					
						self.recordsCsv.push(arrayCsv);
					});
					
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		inLodcard(){			
			//this.linkComments = this.social_options[this.$root.share.social];
		},
		
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style    lang="scss">
	
	
</style>
